<dashboardnav>

    <cradua-damage-list
    [uoms]="uoms$ | async"
    [damagestatuss]="damagestatuss$ | async"
    [measures]="measures$ | async"
    [itemtypes]="itemtypes$ | async"
    [damagelists]="damagelists$ | async"
  
    (changeEmit)="onSubmitDamageList($event)"
    (deleteEvent)="onDeleteDamageList($event)"
    *ngIf="
    !(isLoadingDamageStatus$ | async ) &&
    !(isLoadingUom$ | async ) &&
    !(isLoadingMeasure$ | async ) &&
    !(isLoadingItemType$ | async ) &&
    !(isLoadingDamageList$ | async )
    "
    >
    </cradua-damage-list>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="
    (isLoadingDamageStatus$ | async ) ||
    (isLoadingUom$ | async ) ||
    (isLoadingMeasure$ | async ) ||
    (isLoadingItemType$ | async ) ||
    (isLoadingDamageList$ | async )
    "
  >
    </mrsoftapps-epims-reference-spinner>
  </dashboardnav>
  